module.exports = "../images/trip-advisor.svg?v=22ba033";